<template>
  <div :class="{ 'overflow-x-scroll': scrollX, 'alternate': alternate }">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'TableWrapper',
  props: {
    scrollX: {
      type: Boolean,
      default: false
    },
    alternate: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style lang="scss" scoped>
.table, table {
  width: 100%;
}
</style>
